<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="700px" persistent>
    <v-card>
      <v-card-title class="text-h6">
        {{ title }}
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-combobox
                v-model="localFilters.date_type"
                density="comfortable"
                name="date_type"
                item-title="name"
                item-value="id"
                :items="dateTypes"
                label="Fecha de búsqueda"
                autocomplete="off"
              ></v-combobox>
            </v-col>

            <v-col cols="12" v-if="!isClient">
              <v-text-field v-model="localFilters.wave_id" density="comfortable" label="Ola de preparación" type="number"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-combobox
                v-model="localFilters.document_type"
                name="document_type"
                density="comfortable"
                item-title="name"
                item-value="id"
                :items="documentTypes"
                label="Tipo de Documento"
                autocomplete="off"
                clearable
              ></v-combobox>
            </v-col>

            <v-col cols="12">
              <v-combobox
                v-model="localFilters.status"
                density="comfortable"
                name="status"
                item-title="name"
                item-value="id"
                :items="statusList"
                label="Estado"
                autocomplete="off"
                multiple
                chips
                clearable
              ></v-combobox>
            </v-col>

            <v-col cols="12" v-if="!isClient">
              <v-checkbox
                v-model="localFilters.not_synced_tms"
                density="comfortable"
                label="No sincronizado con TMS"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close"> Cancelar </v-btn>
        <v-btn color="primary" @click="apply"> Aplicar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalFilterShipment",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Filtros Adicionales",
    },
    filters: {
      type: Object,
      required: true,
    },
    dateTypes: {
      type: Array,
      default: () => [],
    },
    documentTypes: {
      type: Array,
      default: () => [],
    },
    statusList: {
      type: Array,
      default: () => [],
    },
    isClient: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localFilters: {
        date_type: null,
        wave_id: null,
        document_type: null,
        status: [],
        not_synced_tms: false,
      },
    };
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.localFilters = {
          date_type: this.filters.date_type,
          wave_id: this.filters.wave_id,
          document_type: this.filters.document_type,
          status: this.filters.status,
          not_synced_tms: this.filters.not_synced_tms || false,
        };
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:modelValue", false);
      this.$emit("close");
    },
    apply() {
      this.$emit("update:filters", this.localFilters);
      this.$emit("apply");
    },
  },
};
</script>

<style scoped>
.v-card-title {
  background-color: #f5f5f5;
  font-weight: 500;
}
</style>
